import type { BlockNode } from '@shared/block-renderer';

/**
 * The write side of the block subsystem. **Bootstrap ships it empty** — the v1
 * block set is contract from the UI/UX pack and from `backend-content`'s
 * stored schema, and it is registered on both sides in the same MR.
 *
 * Two input shapes, one vocabulary: the informational pages render a **field
 * per block** (few blocks, maximum robustness and accessibility) and the
 * editorial post a **continuous `contenteditable` flow** (dozens of blocks in
 * one sitting). Blocks in the flow are normalised **after** input — never by
 * intercepting `Enter`, which breaks the browser's own undo stack, and undo
 * belongs to the writer rather than to the page.
 */

export interface BlockDefinition {
  type: string;
  /** Slash-menu label, from the pack. */
  label: string;
  /** A fresh, empty node of this type. */
  create: (id: string) => BlockNode;
}

export const blockDefinitions: Record<string, BlockDefinition> = {};

export function registerBlockDefinition(definition: BlockDefinition): void {
  blockDefinitions[definition.type] = definition;
}

/** The full type row stays visible below the editor: a type nobody sees is a
 *  type nobody uses. */
export function listBlockDefinitions(): BlockDefinition[] {
  return Object.values(blockDefinitions);
}
